export default __webpack_public_path__ + "static/media/Google.4b7a3906.svg";